import React, {useState, useEffect, Fragment, useRef} from "react"
import ReactToPrint from "react-to-print"
import {useParams} from "react-router-dom"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    Table,
    Spinner,
    Button
} from "reactstrap"
import {useDispatch, useSelector} from "react-redux"
import {getInvoiceDetail} from "@src/views/apps/invoice/store/actions/index"
import {PropTypes} from "prop-types"

const ComponentToPrint = React.forwardRef((props, ref) => (
    <div ref={ref}>
        <Card>
            <CardBody>
                <h1 className="text-center mb-4 mt-2">Invoice</h1>
                <p>
                    <h3>Order :</h3>#
                    {props?.myProps?.data?.id}
                </p>
                <p>
                    <h3>Issue Date :</h3>
                    {props?.myProps?.data?.purchased_date}
                </p>
                <Table className="mb-4">
                    <thead>
                    <tr>
                        <th>Item</th>
                        <th>Original Price</th>
                        <th>Discount</th>
                        <th>Coupon</th>
                        <th>Total Paid</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td scope="row">Annual</td>
                        <td>
                            {props?.myProps?.data?.original_amount}
                        </td>
                        <td>
                            {props?.myProps?.data?.discount || "-"}
                        </td>
                        <td>
                            {props?.myProps?.data?.coupon || "-"}
                        </td>
                        <td>
                            {props?.myProps?.data?.total_amount}
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <b>Total Amount</b>
                        </td>
                        <td>
                            <b>
                                {props?.myProps?.data?.total_amount}
                            </b>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </CardBody>
            <CardFooter style={{backgroundColor: "#1b2033"}}>
                <h5 className="text-center text-white">
                    @ Link by GCG. All rights reserved.
                </h5>
            </CardFooter>
        </Card>
    </div>
))

ComponentToPrint.propTypes = {
    myProps: PropTypes.shape({
        data: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            purchased_date: PropTypes.string,
            original_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            discount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            coupon: PropTypes.string,
            total_amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        })
    })
}

const ViewPaymentInvoice = () => {
    const componentRef = useRef()
    const {id} = useParams()
    const [isTableLoading, setIsTableLoading] = useState(false)

    const paymentHistorySlice = useSelector((store) => store.invoice)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!!paymentHistorySlice?.invoiceDetailData) {
            setIsTableLoading(false)
        }
    }, [paymentHistorySlice])

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        if (!!user && user?.subscriptionexp) history.push('/subscription-plans')

        setIsTableLoading(true)
        dispatch(getInvoiceDetail(id))
    }, [])

    return (
        <div>
            {isTableLoading && ((<div className="w-100 my-4 text-center"><Spinner color='primary'/></div>))}
            {!isTableLoading && (<Fragment>
                <Row className="d-flex justify-content-center">
                    <Col sm="5" md="5" lg="5">
                        <ReactToPrint
                            trigger={() => <Button className="mb-2">Print Invoice</Button>}
                            content={() => componentRef.current}
                        />
                        <ComponentToPrint ref={componentRef} myProps={paymentHistorySlice?.invoiceDetailData}/>
                    </Col>
                </Row>
            </Fragment>)}
        </div>
    )
}

export default ViewPaymentInvoice
